<template>
  <div
    :style="{
      top: `${topOffset / 2}px`
    }"
    class="shadow-title parallax-top-shadow"
  >
    {{ this.$route.name }}
  </div>
</template>

<script>
import { scrollPosition } from "@/components/utils";
export default {
  data() {
    return {
      topOffset: null,
      scrollingAnimation: null
    };
  },
  mounted() {
    window.addEventListener(
      "scroll",
      (this.scrollingAnimation = () => {
        this.topOffset = scrollPosition();
      })
    );
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollingAnimation);
  }
};
</script>

<style lang="scss" scoped>
.shadow-title {
  position: fixed;
  top: 0;
  margin-top: 80px;
  left: 20px;
  width: 100%;
  // height: 300%;
  text-align: left;
  font-family: "Muli", sans-serif;
  writing-mode: vertical-lr;
  font-size: 14vw;
  line-height: 1;
  color: rgba(200, 200, 200, 0.1);
  background: linear-gradient(
    90deg,
    rgba(200, 200, 200, 0),
    rgba(200, 200, 200, 0.65)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
  z-index: -20;
}

@media (max-width: 991px) {
  .shadow-title {
    display: none;
  }
}
</style>
